{{#if images.length}}
{{#each images}}
<div class="column col-4 col-md-6 my-1">
  <div class="mapillary-image p-relative">
    <img src="{{src}}" class="img-responsive" width="{{width}}" height="{{height}}">
    <a class="mapillary-image-link p-absolute px-2" href="https://api.panoramax.xyz/en/index?pic={{id}}&focus=photo" target="_blank" rel="noopener">
      <svg class="icon icon-large"><use xlink:href="#svg-assets-panoramax"></use></svg>
    </a>
    <span class="mapillary-image-user p-absolute px-2 bg-dark">
      @{{user}}, <i>{{capturedAt}}</i>
      <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener">
        <abbr title="Creative Commons Attribution-ShareAlike 4.0 International License">(CC BY-SA 4.0)</abbr>
      </a>
    </span>
  </div>
</div>
{{/each}}
{{else}}
<div class="empty col-12">
  <div class="empty-icon">
    <svg><use xlink:href="#svg-illustration-lost"></use></svg>
  </div>
  <p class="empty-title h5">{{localizer 'panoramax.empty.title'}}</p>
  <p class="empty-subtitle">{{localizer 'panoramax.empty.subtitle'}}</p>
  <div class="empty-action">
    <a class="btn btn-primary" href="{{link}}" target="_blank" rel="noopener">
      <svg class="icon"><use xlink:href="#svg-icon-panorama"></use></svg>
      <span>{{localizer 'panoramax.empty.add'}}</span>
    </a>
  </div>
</div>
{{/if}}
